import React, { useEffect, useState } from 'react'
import {connect, useDispatch, useSelector} from 'react-redux'
import { Field, reduxForm, change, formValueSelector, reset } from 'redux-form'
import {FormButtons, renderers, validations} from '../../../components'
import { GSXService } from '../../../services'
import { DeviceRepairEligibility } from './DeviceRepairEligibility'
import { Button } from 'react-bootstrap'
import * as rest from '../../../services'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import { DeviceActions } from './DeviceActions'
import * as ReactBootstrap from "react-bootstrap";
import {getLists} from "../../../state/lists";

export const RepairTypeRequired = (value) =>
  value || typeof value === 'number' || typeof value === 'boolean'
    ? undefined
    : 'GSX Repair Type is required. Fetch Eligibility to get applicable repair Types.'

const GSXRepairTypeInfoFormName = 'GSXRepairTypeInfoForm'
let GSXRepairTypeInfoForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  dispatch,
  ticket,
}) => {
  const [eligibilityDetails, setEligibilityDetails] = useState(null)
  const [warningMessages, setWarningMessages] = useState([])
  const { gsx_repair_type ,coverage_type} = useSelector((state) => state.lists)
    useEffect(()=>{
     !gsx_repair_type && dispatch(getLists('GSX_REPAIR_TYPE'))
    !coverage_type && dispatch(getLists('COVERAGE_TYPE'))

    // ['gsx_service_type','gsx_repair_type'].map((k)=>{
    //   console.log(k)
    //   dispatch(change(GSXRepairTypeInfoFormName, k, ticket.device[k]))
    // })

  },[])
  const getEligibilityInfo = (identifier) => {
    new GSXService()
      .repair_eligibility({
        identifier: identifier,
      })
      .then((response) => {
        setEligibilityDetails(response.eligibilityDetails)
        let warningMessagesTemp = []
        let repairOptions = []
        response.eligibilityDetails.outcome.forEach((item) => {
          const { reasons } = item
          reasons.forEach((reason) => {
            if (reason.repairOptions) {
              repairOptions = reason.repairOptions
            }
            // warningMessagesTemp = warningMessagesTemp.concat(
            //   reason.messages || []
            // )
          })
        })
        // setWarningMessages(warningMessagesTemp)
        if (repairOptions?.length) {
          dispatch(
            change(
              GSXRepairTypeInfoFormName,
              'gsx_repair_type',
              repairOptions[0].option
            )
          )
          dispatch(
            change(
              GSXRepairTypeInfoFormName,
              'gsx_service_non_repair_type',
              repairOptions[0].subOption
            )
          )
        }
      })
      .catch((_errors) => {
        setEligibilityDetails(null)
      })
  }

  return (
    <>
      <div className="text-end">
        <br />
        <Button
          variant="dark"
          onClick={() => getEligibilityInfo(ticket.device.identifier)}
        >
          Check Repair Eligibility
        </Button>
      </div>
      <form onSubmit={handleSubmit}>
       <Field
              component={renderers.renderSelectField}
              as="select"
              name="gsx_service_type"
              label="GSX Service Type"
              validate={[validations.required]}
            >
              {coverage_type &&
                coverage_type.map((sp) => (
                  <option key={sp.url}  value={sp.code || sp.value}>
                    {sp.value}
                  </option>
                ))}
            </Field>
         <h6>Current Value:{ticket.device.gsx_service_type}</h6>
        <DeviceActions
          identifier={ticket.device.identifier}
          onDeviceInfo={(deviceInfo) => {
            if (deviceInfo.warrantyInfo) {
              dispatch(
                change(
                  GSXRepairTypeInfoFormName,
                  'gsx_service_type',
                  deviceInfo.warrantyInfo.warrantyStatusDescription
                )
              )
            }
          }}
          eligibilityDetails={eligibilityDetails}
          warningMessages={warningMessages}
        />
        {eligibilityDetails && (
          <DeviceRepairEligibility
            device_identifier={ticket.device.identifier}
            eligibilityDetails={eligibilityDetails}
            warningMessages={warningMessages}
          />
        )}
        <Field
              component={renderers.renderSelectField}
              as="select"
              name="gsx_repair_type"
              label="GSX Repair Type"
              validate={[validations.required]}
            >
              {gsx_repair_type &&
                gsx_repair_type.map((sp) => (
                  <option key={sp.url}  value={sp.code || sp.value}>
                    {sp.value}
                  </option>
                ))}
            </Field>
        <h6>Current Value:{ticket.device.gsx_repair_type}</h6>
        <Field
          component={renderers.renderSelectField}
          as="select"
          name="gsx_service_non_repair_type"
          label="GSX Service Non Repair Type"
        >
          {['NTF', 'SRC', 'LUA', 'CUA'].map((sp) => (
            <option key={sp} value={sp}>
              {sp}
            </option>
          ))}
        </Field>
        <h6>Current Value:{ticket.device.gsx_service_non_repair_type}</h6>

        <ReactBootstrap.Col xs={12}>
          <Field
            name="inward_date_for_repair"
            label="Repair Time For GSX Repair"
            component={renderers.renderDateTimePicker}
            dateFormat="MMMM d, yyyy h:mm aa"
          />
           <h6>Current Value:{ticket.device.inward_date_for_repair}</h6>
        </ReactBootstrap.Col>



        <FormButtons
          submitting={submitting}
          pristine={pristine}
          reset={reset}
        />
      </form>
    </>
  )
}

GSXRepairTypeInfoForm = reduxForm({
  form: GSXRepairTypeInfoFormName,
})(GSXRepairTypeInfoForm)
const selector = formValueSelector(GSXRepairTypeInfoFormName)
GSXRepairTypeInfoForm = connect((state) => {
  const selected_gsx_repair_type = selector(state, 'gsx_repair_type')
  return {
    selected_gsx_repair_type,
  }
})(GSXRepairTypeInfoForm)

const GSXRepairTypeInfo = ({ ticket, onTicketUpdate }) => {
  const dispatch = useDispatch()
  const GSXRepairTypeInfoFormWithData = connect((state) => ({
    initialValues: ticket.device,
  }))(GSXRepairTypeInfoForm)
  useEffect(() => {
    connect((state) => ({
      initialValues: ticket.device,
    }))
  }, [])
  const updateDeviceInformation = (data) => {
    new rest.DeviceService(ticket.device.url)
      .makePutRequest({ ...ticket.device, ...data })
      .then((response) => {
        onTicketUpdate({...ticket,device:response})
        dispatch(
          showSuccessToast(
            'Success',
            `Ticket GSX Repair Type Information has been saved.`
          )
        )
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <>
      <GSXRepairTypeInfoFormWithData
        ticket={ticket}
        onSubmit={updateDeviceInformation}
      />
    </>
  )
}
export default GSXRepairTypeInfo
